import { Buffer } from 'buffer';
import * as waxjs from "@waxio/waxjs/dist";

window.Buffer = Buffer;

const rpcEndpoints = [
  /*
  "https://api.wax.alohaeos.com",
"https://wax.eu.eosamsterdam.net",
"https://api.wax.bountyblok.io",
"https://wax.eosphere.io",
"https://wax.cryptolions.io",
"https://wax.dapplica.io",
"https://api.waxsweden.org",
"https://wax.pink.gg",
"https://wax-public1.neftyblocks.com",
"https://wax-public2.neftyblocks.com",
"https://api-wax.tacocrypto.io",
"https://api.waxdaobp.io",
"https://wax.eosusa.io",
"https://wax.api.eosnation.io",
*/
"https://wax.greymass.com",
];

const Testnet_rpcEndpoints = [  
"http://testnet.waxsweden.org",
];

// const getRandomEndpoint = () => {
//   return Testnet_rpcEndpoints[Math.floor(Math.random() * Testnet_rpcEndpoints.length)];
// };

const getRandomEndpoint = () =>
  rpcEndpoints[Math.floor(Math.random() * rpcEndpoints.length)];

const selectedEndpoint = getRandomEndpoint();
//console.log("[WAX] Using RPC Endpoint:", selectedEndpoint);

const wax = new waxjs.WaxJS({
  rpcEndpoint: selectedEndpoint,
  tryAutoLogin: false,
});

export const ensureWaxApi = async () => {
  if (!wax.api) {
    try {
      await wax.login(); // kullanıcıdan login izni ister
    } catch (err) {
      console.error("❌ Auto-login failed:", err);
      throw new Error("WAX API not available and login failed.");
    }
  }
};

export default wax;
